<template>
    <transition name="fade">
        <div class="app__loader" v-if="this.getLoadStatus">
            <div class="loader">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    </transition>
</template>

<script>
    import { mapGetters } from 'vuex'
    export default {
        name: 'Loading',
        computed: mapGetters(['getLoadStatus'])
    }
</script>